<template>
  <div class="page">
    <img class="img-cover" :src="coverPath">
    <div class="finish-box" @click="showImg($event)" v-html="content" />
  </div>
</template>

<script>
import { Toast, ImagePreview } from 'vant'
import { getActivityInfo } from '@/api/apply'
import { getUrlKey } from '@/utils/index' // 获取url参数
import { visit } from '@/api/statistics'

export default {
  name: 'Finish',
  components: {
    [ImagePreview.name]: ImagePreview
  },
  data() {
    return {
      coverPath: null,
      content: ''
    }
  },
  created() {
    const activityId = getUrlKey('activityId')
    if (activityId) {
      this.activityId = activityId
      const activity = JSON.parse(sessionStorage.getItem('activity_' + activityId))
      if (activity) {
        this.coverPath = activity.image
        this.content = activity.enroll_content
      } else {
        this.initData(activityId)
      }
    }
  },
  methods: {
    initData(id) {
      getActivityInfo({ 'activity_id': id }).then(resolve => {
        if (resolve.data.code === 200) {
          this.coverPath = resolve.data.data.image
          this.content = resolve.data.data.enroll_content
        } else {
          Toast(resolve.data.data)
        }
      })
      // 记录PV和UV
      visit(id + '号活动报名首页', id)
    },
    showImg(e) {
      if (e.target.tagName === 'IMG') {
        ImagePreview({
          images: [
            e.target.src
          ]
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .page{
    width: 375px;
    .img-cover{
      width: 100%;
      margin-bottom: 10px;
    }
  }
  .finish-box{
    background: #fff;
    width:320px;
    margin:0 auto;
    padding:10px 10px;
    img {
      max-width:100%;
    }
  }
</style>
